
import React from "react";
import { PostConfigData, QuizConfigData, QuizResults, QuizAnswerConfig, ChatConfigData, SubmissionCompetitionConfigData, CreativeConfigData, ActivityBlockConfigData } from "../Shared/Party/PartyConfigData";
import { CreativePanel } from "./CreativePanel";
import { LiveMessageFeed } from "./LiveMessageFeed";
import { PostDisplayProps, PostProps, Post } from "./Post";
import { QuizPanelDisplayProps, QuizPanel } from "./QuizPanel";
import { SubmissionCompetitionDisplayProps, SubmissionCompetition } from "./SubmissionCompetition";
import { UIConfigContext } from "./UIConfigContext";
import { StateManagerContext } from "./StateManagerContext";

export type ActivityDisplayProps = {
    activity : ActivityBlockConfigData,
    main : boolean,

}

export const ActivityDisplay = ({activity, main} : ActivityDisplayProps) =>{

    const uiConfig = React.useContext(UIConfigContext);
    const stateManager = React.useContext(StateManagerContext);
    var chunkDisplay: JSX.Element | null = null;

    const postHeight = uiConfig.mainSpan[1] - uiConfig.mainSpan[0];


     if (activity.activityType === 'post') {
        const post = activity.config as PostConfigData;
        const postDisplayProps: PostDisplayProps = {
          postHeight: postHeight - 400,//mainActivity.current.chatSource === 'integrated' ? postHeight - 400 : postHeight,
          messageHeight: 400,//mainActivity.current.chatSource === 'integrated' ? 400 : 0,
          userId: stateManager.user().fanbox.id,
        };
    
    
    
    
        const postProps: PostProps = { config: post, display: postDisplayProps };
        chunkDisplay = <Post {...postProps} key={'POST_' + post.itemId} />;
      }
      else if (activity.activityType === 'quiz') {
        const quizConfig = activity.config as QuizConfigData;
        const quizResults: QuizResults = {
          results: {},
          timeBonus: 0,
          answerPoints: 0
        };
        const complete = (points: number, time: number) => { //TODO
    
        }
    
        const getGenerator = (name: string) => {
          return {
            getAnswers: (state: string) => Array<QuizAnswerConfig>(),
            submitAnswer: (state: string, props: QuizAnswerConfig) => ''
          }
        }
    
        const quizDisplay: QuizPanelDisplayProps = {
          complete: complete,
          getGenerator: getGenerator,
          imagePadding: 10,
          textPadding: 20,
          fontbase: uiConfig.fontBase,
          availableHeight: postHeight,
          headerBar: 'compact',
          numberInParty: stateManager.activity().national,
          quizOpened:activity.startTime,
          quizCloses: activity.endTime,
          partyId: stateManager.context().itemId
        }
        chunkDisplay = <QuizPanel quiz={quizConfig} display={quizDisplay} results={quizResults} />
      }
      else if (activity.activityType === 'chat') {
        const chat = activity.config as ChatConfigData;
        chunkDisplay = <LiveMessageFeed chatId={chat.itemId}
          chat={chat}
          height={postHeight}
          currentUser={stateManager.user().fanbox.id} />
    
      }
      else if (activity.activityType === 'submission') {
        const submissionConfig = activity.config as SubmissionCompetitionConfigData;
        const submissionDisplay: SubmissionCompetitionDisplayProps = {
          height: postHeight,
        }
        chunkDisplay = <SubmissionCompetition config={submissionConfig} display={submissionDisplay} />
      }
      else {
        const creativeConfig = activity.config as CreativeConfigData;
        chunkDisplay = <CreativePanel config={creativeConfig}  height={postHeight}  key={'CREATIVE_' + creativeConfig.itemId}/>
      }



     
      if(chunkDisplay === null)
        return <div></div>
        else
        return chunkDisplay;
}